import parse from "html-react-parser";
import { sanitizeHtml } from "./sanitizeHtml";

// html-react-parser renders a javascript: link and copies unknown attributes: stored HTML is cleaned first.
export const parseSafeHtml = (html: string) => parse(sanitizeHtml(html));
